import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnitService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.stanthonyUrl}/unit`,{params:searchParams});
    }

    get(Id){
      return this.http.get(`${environment.stanthonyUrl}/unit/`+Id);
    }

    edit(Id,formData){
      return this.http.put(`${environment.stanthonyUrl}/unit/`+Id,formData);
    }

    create(formData){
      return this.http.post(`${environment.stanthonyUrl}/unit`,formData);
    }

    delete(Id){
      return this.http.delete(`${environment.stanthonyUrl}/unit/`+Id);
    }

}
